import React from "react";
import "../assets/css/footer.css";

function Footer() {
  return (
    <div>
      <div className="Footer pb-4">
        <div style={{ margin: "10px 10px 0px 10px", width: "100%" }}>
          <footer className="pt-3 my-4 ">
            <ul className="nav navmain  pb-1 bordercolor">
              <div className="d-inline-flex px-0">
              {/* <li className="nav-item d-flex   ">
                  <a
                    target="_blank"
                    className="nav-link text-muted "
                    rel="noreferrer"
                    href="https://www.reddit.com/"
                  >
                    <i className="bi bi-reddit"></i>
                  </a>
                </li> */}
                <li className="nav-item d-flex   ">
                  <a
                    target="_blank"
                    className="nav-link text-muted "
                    rel="noreferrer"
                    href="https://twitter.com/rajeduofficial?lang=en"
                  >
                    <i className="bi bi-twitter"></i>
                  </a>
                </li>
              <li className="nav-item d-flex   ">
                  <a
                    target="_blank"
                    className="nav-link text-muted "
                    rel="noreferrer"
                    href="https://www.youtube.com/channel/UClCI9cgD2zxr6xhT2gm7AQA "
                  >
                    <i className="bi bi-youtube"></i>
                  </a>
                </li>
                <li className="nav-item d-flex   ">
                  <a
                    target="_blank"
                    className="nav-link text-muted "
                    rel="noreferrer"
                    href="https://www.facebook.com/rajeduofficial"
                  >
                    <i className="bi bi-facebook"></i>
                  </a>
                </li>
                {/* <li className="nav-item d-flex  ">
                  <a
                    target="_blank"
                    className="nav-link text-muted "
                    rel="noreferrer"
                    href="https://www.instagram.com/"
                  >
                    <i className="bi bi-instagram"></i>
                  </a>
                </li>
                <li className="nav-item   d-flex  ">
                  <a
                    target="_blank"
                    className="nav-link text-muted "
                    rel="noreferrer"
                    href="https://www.linkedin.com/"
                  >
                    <i className="bi bi-linkedin"></i>
                  </a>
                </li> */}
              </div>
              
            </ul>
            
            {/* <p className=" license text-center text-muted pt-3">Developed by <a
                    target="_blank"
                    className="license nav-link text-muted "
                    rel="noreferrer"
                    href="https://www.linkedin.com/company/gdscgtbit/?originalSubdomain=in"
                  >
                    <u>GDSC-GTBIT</u></a></p> */}
          </footer>
        </div>
      </div>
    </div>
  );
}

export default Footer;
